<!-- <div class="container discord-status"> -->
<app-card [color]="isDiscordSuccess() ? 'green' : 'red'" layout="status-card">
  <p card-value>Discord</p>
  <div card-label>
    <div>
      Status:
      <span
        class="highlight"
        [class.red]="!isDiscordSuccess()"
        [class.green]="isDiscordSuccess()"
      >
        @if (isDiscordSuccess()) { Joined } @else { Not Joined }
      </span>
    </div>
  </div>
  <div card-button class="discord-status--buttons">
    <a
      class="discord-status--button join"
      [href]="DISCORD_LINK"
      target="_blank"
    >
      <svg-icon
        class="flex items-center justify-center s-16"
        src="assets/icons/socials/discord.svg"
      />
      Join Discord
    </a>
    <button
      class="discord-status--button link"
      (click)="sessionService.authDiscord()"
    >
      <svg-icon
        class="flex items-center justify-center s-16"
        src="assets/icons/socials/discord.svg"
      />
      Link Discord
    </button>
  </div>
</app-card>
<!-- </div> -->
